/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M3.50024 5.50012L5.00024 4.00012M5.00024 4.00012L6.50024 2.50012M5.00024 4.00012L3.50024 2.50012M5.00024 4.00012L6.50024 5.50012M3.50024 13.5001L5.00024 12.0001M5.00024 12.0001L6.50024 10.5001M5.00024 12.0001L3.50024 10.5001M5.00024 12.0001L6.50024 13.5001M3.50024 21.5001L5.00024 20.0001M5.00024 20.0001L6.50024 18.5001M5.00024 20.0001L3.50024 18.5001M5.00024 20.0001L6.50024 21.5001"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.0002 20.0001L22.0002 20.0001M11.0002 12.0001L22.0002 12.0001M11.0002 4.00012H22.0002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M3.50024 5.50012L5.00024 4.00012M5.00024 4.00012L6.50024 2.50012M5.00024 4.00012L3.50024 2.50012M5.00024 4.00012L6.50024 5.50012M3.50024 13.5001L5.00024 12.0001M5.00024 12.0001L6.50024 10.5001M5.00024 12.0001L3.50024 10.5001M5.00024 12.0001L6.50024 13.5001M3.50024 21.5001L5.00024 20.0001M5.00024 20.0001L6.50024 18.5001M5.00024 20.0001L3.50024 18.5001M5.00024 20.0001L6.50024 21.5001M11.0002 20.0001L22.0002 20.0001M11.0002 12.0001L22.0002 12.0001M11.0002 4.00012H22.0002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M3.5 5.5L5 4M5 4L6.5 2.5M5 4L3.5 2.5M5 4L6.5 5.5M3.5 13.5L5 12M5 12L6.5 10.5M5 12L3.5 10.5M5 12L6.5 13.5M3.5 21.5L5 20M5 20L6.5 18.5M5 20L3.5 18.5M5 20L6.5 21.5M11 20L22 20M11 12L22 12M11 4H22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M3.50024 5.50012L5.00024 4.00012M5.00024 4.00012L6.50024 2.50012M5.00024 4.00012L3.50024 2.50012M5.00024 4.00012L6.50024 5.50012M3.50024 13.5001L5.00024 12.0001M5.00024 12.0001L6.50024 10.5001M5.00024 12.0001L3.50024 10.5001M5.00024 12.0001L6.50024 13.5001M3.50024 21.5001L5.00024 20.0001M5.00024 20.0001L6.50024 18.5001M5.00024 20.0001L3.50024 18.5001M5.00024 20.0001L6.50024 21.5001M16.0002 20.0001H11.0002M22.0002 20.0001H20.0002M17.0002 12.0001H22.0002H11.0002H13.0002M16.0002 4.00012H11.0002M22.0002 4.00012H20.0002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M3.50024 5.50012L5.00024 4.00012M5.00024 4.00012L6.50024 2.50012M5.00024 4.00012L3.50024 2.50012M5.00024 4.00012L6.50024 5.50012M3.50024 13.5001L5.00024 12.0001M5.00024 12.0001L6.50024 10.5001M5.00024 12.0001L3.50024 10.5001M5.00024 12.0001L6.50024 13.5001M3.50024 21.5001L5.00024 20.0001M5.00024 20.0001L6.50024 18.5001M5.00024 20.0001L3.50024 18.5001M5.00024 20.0001L6.50024 21.5001M11.0002 20.0001L22.0002 20.0001M11.0002 12.0001L22.0002 12.0001M11.0002 4.00012H22.0002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M3.5 5.5L5 4M5 4L6.5 2.5M5 4L3.5 2.5M5 4L6.5 5.5M3.5 13.5L5 12M5 12L6.5 10.5M5 12L3.5 10.5M5 12L6.5 13.5M3.5 21.5L5 20M5 20L6.5 18.5M5 20L3.5 18.5M5 20L6.5 21.5M11 20L22 20M11 12L22 12M11 4H22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
